import React, { useState } from "react";
import Box from "@mui/material/Box";
import Menu, { MenuProps } from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import MenuIcon from "@mui/icons-material/Menu";
import { navigate } from "gatsby";

type AppBarMenuProps = {
  pages: Array<{
    pageName: string;
    path: string;
  }>;
  sx?: MenuProps["sx"];
};

const AppBarMenu = ({ pages, sx }: AppBarMenuProps) => {
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleClose = (path: string) => {
    navigate(path);
    handleCloseNavMenu();
  };

  return (
    <Box sx={sx}>
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleOpenNavMenu}
        color="inherit"
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorElNav}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={Boolean(anchorElNav)}
        onClose={handleCloseNavMenu}
        sx={{
          display: { xs: "block", md: "none" },
        }}
      >
        {pages.map((page) => (
          <MenuItem key={page.pageName} onClick={() => handleClose(page.path)}>
            <Typography textAlign="center">{page.pageName}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default AppBarMenu;
